<section *ngIf="(quickCallBasicInfoResponse | searchFilterPipe:'name':searchQuickCall) as filteredResult;">
    <div class="row" id="quickcalllistheader">
        <div class="col-md-6 col-xl-6 col-lg-6 col-12 col-sm-12 zsd-cust-common-pageheading-font active">
            <img src="img/quickcalltemplate.svg" />
            {{ 'QuickCallList.heading' | translate }} ({{filteredResult.length}})</div>
        <div class="col-md-6 col-xl-6 col-lg-6 col-12 col-sm-12">
            <input class="form-control ng-pristine ng-valid ng-touched" id="quickcallsearch" name="search"
                [(ngModel)]="searchQuickCall" type="search"
                placeholder="{{ 'QuickCallList.searchplaceholder' | translate }}" autocomplete="off">
        </div>
    </div>

    <div class="card table-container">
        <div class="card-body" id="quickcall_card_body">
            <!-- <div id="item_container"> -->
            <table class="" id="c_quickcall_table">
                <!-- <thead> -->
                <tr id="c_cust-table-header" class="cust-table-header">
                    <th (click)="sort('quickCallType')" style="flex: 0 0 100px; width: 3%;" id="quickcall_type">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (sortColumn == 'quickCallType' && !isDesc), 'fas fa-sort-up': (sortColumn == 'quickCallType' && isDesc) }"
                            aria-hidden="true">
                        </em>
                    </th>
                    <th (click)="sort('name')" style="flex: 0 0 100px; width: 30%;" id="quickcall_name">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (sortColumn == 'name' && !isDesc), 'fas fa-sort-up': (sortColumn == 'name' && isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'QuickCallList.name' | translate }}
                    </th>
                    <th (click)="sort('description')" style="flex: 0 0 100px; width:30%;" id="quickcall_priority">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (sortColumn == 'description' && !isDesc), 'fas fa-sort-up': (sortColumn == 'description' && isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'QuickCallList.description' | translate }}
                    </th>
                    <th (click)="sort('classification')" style="flex: 0 0 100px; width:12%;"
                        id="quickcall_classification">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (sortColumn == 'classification' && !isDesc), 'fas fa-sort-up': (sortColumn == 'classification' && isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'QuickCallList.classification' | translate }}
                    </th>

                    <th style="flex: 0 0 100px;width:25%" id="quickcall_priority">

                        {{ 'QuickCallList.item' | translate }}
                    </th>

                </tr>
                <tbody>
                    <tr class="table-body"
                        *ngFor="let quickCall of filteredResult  | sortList:sortColumn:sortOrder:false"
                        id="c_quickcall_table_body" (click)=getQuickCallinfo(quickCall) data-toggle="modal"
                        data-target="#zsd_modal_quickcall_detail">
                        <td *ngIf="quickCall.quickCallType==='Quick Call'; else elseQuickCall">
                            <img src="img/quickcall.svg" />
                        </td>
                        <ng-template #elseQuickCall>
                            <td><img src="img/groupquickcall.svg" /></td>
                        </ng-template>
                        <td *ngIf="quickCall.name.length<120; else elseBlock">{{ quickCall.name }}</td>
                        <ng-template #elseBlock>
                            <td data-toggle="tooltip" data-placement="left" title="{{ quickCall.name }}">
                                {{ quickCall.name.slice(0,119)+'...' }}</td>
                        </ng-template>
                        <td *ngIf="quickCall.description.length<120; else elseDescription">{{ quickCall.description }}
                        </td>
                        <ng-template #elseDescription>
                            <td data-toggle="tooltip" data-placement="left" title="{{ quickCall.description }}">
                                {{ quickCall.description.slice(0,119)+'...' }}</td>
                        </ng-template>
                        <td>{{ quickCall.classification }}</td>
                        <td>{{ getQuickCallItemName(quickCall) }}</td>
                    </tr>
                    <tr *ngIf="filteredResult.length > 20" class="norecords">
                        <td colspan="5" class="text-center">{{ 'CommonStrings.endOfScroll' | translate }}</td>
                    </tr>
                    <tr *ngIf="(filteredResult.length <= 0) && !(isLoading || spinnerStart)" class="norecords">
                        <td colspan="5" class="text-center">{{ 'CommonStrings.noRecords' | translate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Spinner -->
        <div class="text-center col-12" id="sd_store_item_loading ">
            <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
                <zsd-spinner></zsd-spinner>
            </div>
        </div>
    </div>
</section>

<div *ngIf='quickCallId' class="modal" id="zsd_modal_quickcall_detail" data-backdrop="static" data-keyboard="false">
    <div class="modal-content">
        <div class="modal-header">
            <div id="popupDefaultFont">
                <span *ngIf="quickCallTypeKey==='quickCall'" class="quickCallPopupHeader">
                    <img src="img/quickcallheader.svg" /> {{'QuickCallList.quickcall' | translate}} </span>
                <span *ngIf="quickCallTypeKey==='groupQuickCall'" class="quickCallPopupHeader">
                    <img src="img/groupquickcallheader.svg" /> {{'QuickCallList.groupquickcall' | translate}} </span>
                {{quickCallName}}</div>
            <button (click)="resetQuickCall()" type="button" class="close" data-dismiss="modal"><em
                    class="fas fa-times"></em></button>
        </div>
        <div class="modal-body" id="override_modal_body">
            <zsd-quickcalldetail [quickCallId]="quickCallId" [quickCallType]="quickCallTypeKey"
                (clearForm)="resetQuickCall()"></zsd-quickcalldetail>
        </div>
    </div>
</div>